
import { merge } from "lodash";
import { generateEndpoints, prefix } from "../helpers";

/**
 * This is the reource identifier
 * Everything will be under users.get, users.getAll, users.create, users.createAndSendEmail etc...
 */
const namespace = "landingcontact";

const nameSpace = merge({}, generateEndpoints(namespace), {
  get: {
    // extend=referral: senza di esso `referral` resta l'arricchimento mandator
    // ({referral,url}) o una stringa; con extend è la ReferralData
    // ({referralCode,subscriptionLogo}) che serve a brandizzare la registrazione
    // (PILLARS-3267).
    getFromToken: (token) => [`${prefix}/profile/${namespace}/token/${token}?extend=referral`],
    getFromEmail: (email) => [`${prefix}/profile/${namespace}/email/${email}?extend=referral`],
    getFromNetworkCode: (code) => [`${prefix}/profile/${namespace}/network/${code}`],
    getFromId: (id) => [`${prefix}/profile/internal/invitation/${id}`]
  },
  post: {
    create: (data) => [`${prefix}/profile/${namespace}/`, data]
  },
})

export default nameSpace;
